import styled, { css } from 'styled-components';

import { mediaMixin, mediaQueryMixin, spaceMixin, token } from '@zillow/constellation';

const getMinHeightXL = (minHeightXL: string) => css`
  ${mediaMixin(
    'xl',
    css`
      min-height: ${minHeightXL};
    `,
  )}
`;

const getCardHoverStyle = () => {
  return css`
    background-color: ${token('colors.blue100')};
    border-color: ${token('colors.blue400')};
  `;
};

const getMediaQueryStyles = (mediaProps: {
  borderBottom: string;
  borderTop: string;
  borderLeft: string;
  borderRight: string;
  hideBorder: boolean;
}) => {
  const DEFAULT_BORDER = '1px solid #D1D1D5';

  if (mediaProps.hideBorder) {
    return css`
      border: none;
    `;
  }

  return css`
    border-top: ${mediaProps.borderTop && mediaProps.borderTop !== 'unset' ? mediaProps.borderTop : DEFAULT_BORDER};

    border-bottom: ${mediaProps.borderBottom && mediaProps.borderBottom !== 'unset'
      ? mediaProps.borderBottom
      : DEFAULT_BORDER};

    border-left: ${mediaProps.borderLeft && mediaProps.borderLeft !== 'unset' ? mediaProps.borderLeft : DEFAULT_BORDER};

    border-right: ${mediaProps.borderRight && mediaProps.borderRight !== 'unset'
      ? mediaProps.borderRight
      : DEFAULT_BORDER};
  `;
};

export const StyledConnectedCard = styled.div<{
  includeBorderTop: boolean;
  borderRadius: string;
  enableHover: boolean;
  minHeightXL: string;
  mediaQuery: Record<string, string> | null;
}>`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: ${spaceMixin('sm')};
  background-color: ${token('colors.white')};

  border: 1px solid ${token('colors.gray300')};
  border-top: ${({ includeBorderTop }) => includeBorderTop && '3px solid #006AFF'};
  border-radius: ${({ borderRadius }) => borderRadius};

  ${mediaQueryMixin(getMediaQueryStyles)}
  ${({ minHeightXL }) => minHeightXL && getMinHeightXL(minHeightXL)}

  /* helps vertically center the spinner */
  .SpinnerContainer {
    flex-grow: 2;
  }

  ${({ enableHover }) => enableHover && getCardHoverStyle()}

  /* 769 */
  ${mediaMixin(
    'lg',
    css`
      padding: ${spaceMixin('md')} ${spaceMixin('lg')} ${spaceMixin('lg')} ${spaceMixin('lg')};
    `,
  )}
`;

export const StyledHeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${spaceMixin('sm')};
  justify-content: ${({ justifyHeadingContent }: { justifyHeadingContent: string }) => justifyHeadingContent};

  /* 769 */
  ${mediaMixin(
    'lg',
    css`
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: ${spaceMixin('md')};
    `,
  )}
`;
